export const columns = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '活动名称',
    dataIndex: 'name',
  },
  {
    title: '活动图标',
    dataIndex: 'icon',
    scopedSlots: { customRender: 'icon' },
  },
  {
    title: '活动类型',
    customRender: (text, record)=>{
      return record.type===0?'常规活动':'需定位活动';
    },
  },
  {
    title: '活动描述',
    dataIndex: 'summary',
  },
  {
    title: '排序',
    dataIndex: 'sort',
  },
  {
    title: '状态',
    customRender: (text, record)=>{
      return record.status===0?'禁用':'启用';
    },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];

export const formData = [
  {
    name: 'name',
    lable: '活动名称',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 24,
  },
  {
    name: 'flag',
    lable: '活动标志',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 24,
  },
  {
    name: 'type',
    lable: '活动类型',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 24,
  },
  {
    name: 'sort',
    lable: '排序',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 24,
  },
  {
    name: 'icon',
    lable: '活动图标',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 24,
  },
  {
    name: 'summary',
    lable: '活动描述',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 24,
  },
  {
    name: 'report_html',
    lable: '报告渲染代码',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 24,
  },

];